import { SvgIcon } from '@progress/kendo-react-common';
import { ArrowUpOutline, RefreshOutline } from '../../../../../../../icons/icons';

export function AlertRepeatsIconIcon({ show }: { show: boolean | null | undefined }) {
    if (show) {
        return <SvgIcon icon={RefreshOutline} />;
    }
    return null;
}

export function AlertTriggerImprovingIcon({ show }: { show: boolean | null | undefined }) {
    if (show) {
        return <SvgIcon icon={ArrowUpOutline} />;
    }
    return null;
}
